import { Base } from 'app/components/ui/Base'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { useLayout } from 'app/contexts/LayoutProvider'
import { routes } from 'app/routing/routes'
import React, { useLayoutEffect } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { ForgotPasswordForm } from './ForgotPasswordForm'

export const ForgotPassword = (): JSX.Element => {
  const { updateLayoutData } = useLayout()

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Area sponsor Marketing',
      subTitle: 'Azzera la tua Password',
      headerVariant: 'authentication',
    })
  }, [updateLayoutData])

  return (
    <Base>
      <Container>
        <PageGrid>
          <TextColumn>
            <Text variant='s20'>
              <div>
                Inserisci l&apos;indirizzo con cui ti sei registrato e riceverai
                una mail con le istruzioni per cambiare la password e accedere
                al sistema.{'\n\n'}
                <Link to={routes.login.path}>Torna indietro</Link>
              </div>
            </Text>
          </TextColumn>
          <FormColumn>
            <ForgotPasswordForm />
          </FormColumn>
        </PageGrid>
      </Container>
    </Base>
  )
}

const PageGrid = styled.div`
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;

  display: grid;
  grid-gap: 4rem;

  grid-template-columns: 1fr;

  grid-template-areas:
    'text'
    'form';

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    grid-template-columns: 2fr 1fr 400px 1fr 2fr;

    grid-template-areas:
      '. text text text .'
      '. . form.  .';
  }

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 'text form';
  }
`

const TextColumn = styled.div`
  grid-area: text;
`

const FormColumn = styled.div`
  grid-area: form;
`
